import React from "react";
import { Navigate } from "react-router";
import { usePermissions } from "src/contexts/permissions";
import useAuth from "src/hooks/useAuth";

const LEGACY_INSIGHTS_ROLES = ["admin", "super_admin", "manager", "inventory", "billing_user"];

const InsightsGuard = ({ children }) => {
  const { isAuthenticated, user } = useAuth();
  const { can } = usePermissions();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  const legacyRoleAllowed = LEGACY_INSIGHTS_ROLES.includes(user?.role);
  if (!legacyRoleAllowed && !can("insights.page")) {
    return <Navigate to="/403" replace />;
  }

  return <>{children}</>;
};

export default InsightsGuard;
